// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.C7thQ1oicKAkghpP {
  margin: 20px auto;
  width: calc(100vw - 60px);
}
.C7thQ1oicKAkghpP .j1Tf1F92k7EbozCH {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.C7thQ1oicKAkghpP .j1Tf1F92k7EbozCH .MZYeXebNzuQpvDnz {
  margin-left: 12px;
}
.C7thQ1oicKAkghpP .YcUdBTFv30g6_qZn {
  margin-top: 10px;
}
.C7thQ1oicKAkghpP .YcUdBTFv30g6_qZn .mBDRmp6eeBsni0qu {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.C7thQ1oicKAkghpP .YcUdBTFv30g6_qZn .mBDRmp6eeBsni0qu .E_XsfxqWxoZaBg26 {
  margin-right: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.C7thQ1oicKAkghpP .YcUdBTFv30g6_qZn .mBDRmp6eeBsni0qu .E_XsfxqWxoZaBg26 .eKt3nK0FWa87qO_G {
  margin-left: 5px;
}
.C7thQ1oicKAkghpP .YcUdBTFv30g6_qZn .jmqKFPShXYIWyE1Y {
  height: auto !important;
}
.C7thQ1oicKAkghpP .bz8igFQoUpQK0Ds7 {
  position: relative;
  padding: 4px 0;
}
.C7thQ1oicKAkghpP .bz8igFQoUpQK0Ds7 .QxjjBhfpp30fhoQW {
  line-height: 1.6;
}
.C7thQ1oicKAkghpP .bz8igFQoUpQK0Ds7 .iI4KbSvrUjIWRhyq {
  font-size: 12px;
  color: #999;
  font-weight: bold;
  cursor: pointer;
  margin-top: 2px;
}
.C7thQ1oicKAkghpP .bz8igFQoUpQK0Ds7 .YQb0pehE0ncGb6uq {
  display: none;
  position: absolute;
  width: 300px;
  max-height: 200px;
  overflow-y: auto;
  top: 100%;
  left: 0;
  z-index: 999;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  margin-top: 4px;
  padding: 4px 8px;
}
.C7thQ1oicKAkghpP .bz8igFQoUpQK0Ds7 .YQb0pehE0ncGb6uq.VSIGrhmL_QUjBJni {
  display: block;
}
.C7thQ1oicKAkghpP .bz8igFQoUpQK0Ds7 .YQb0pehE0ncGb6uq .fMsAwJ3NAPAeL9NH {
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
  line-height: 1.6;
}
.C7thQ1oicKAkghpP .bz8igFQoUpQK0Ds7 .YQb0pehE0ncGb6uq .fMsAwJ3NAPAeL9NH:last-child {
  border-bottom: none;
}
.C7thQ1oicKAkghpP .iDzBdqmcto8q4ycM {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.C7thQ1oicKAkghpP .iDzBdqmcto8q4ycM ._cTGRYKTUKgk5Uo4 {
  width: 10px;
  height: 10px;
  background: #52c41a;
  border-radius: 50%;
  margin-right: 5px;
}
.C7thQ1oicKAkghpP .GlhocLTKrUsteDyc {
  color: #1677ff;
  font-weight: bold;
}
.C7thQ1oicKAkghpP .uzCcsw4oSskOfvMF {
  width: 100%;
}
.Wz9W9ccCmgwHodFs {
  width: 100%;
  margin: 0;
  padding: 12px 12px 24px;
  box-sizing: border-box;
}
.Wz9W9ccCmgwHodFs .j1Tf1F92k7EbozCH {
  justify-content: stretch;
  gap: 12px;
}
.Wz9W9ccCmgwHodFs .j1Tf1F92k7EbozCH .MZYeXebNzuQpvDnz {
  margin-left: 0;
}
.Wz9W9ccCmgwHodFs .j1Tf1F92k7EbozCH button {
  flex: 1;
}
.Wz9W9ccCmgwHodFs .YcUdBTFv30g6_qZn .mBDRmp6eeBsni0qu {
  overflow-x: auto;
  margin-bottom: 12px;
  padding-bottom: 4px;
}
.Wz9W9ccCmgwHodFs .YcUdBTFv30g6_qZn .mBDRmp6eeBsni0qu .E_XsfxqWxoZaBg26 {
  margin-right: 16px;
  flex-shrink: 0;
  white-space: nowrap;
  min-height: 36px;
  padding: 6px 2px;
}
.Wz9W9ccCmgwHodFs .YcUdBTFv30g6_qZn .mBDRmp6eeBsni0qu .E_XsfxqWxoZaBg26.GlhocLTKrUsteDyc {
  color: #1677ff;
  font-weight: 600;
  box-shadow: inset 0 -2px 0 #1677ff;
}
.Wz9W9ccCmgwHodFs .CHTpelOoXRQMA7XS {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Wz9W9ccCmgwHodFs .Xm0RXffSZCoKJBR7 {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
}
.Wz9W9ccCmgwHodFs .K6X9o26VYI0DYefH {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}
.Wz9W9ccCmgwHodFs .VM9cXdGUGo1mf9Hc {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  word-break: break-all;
}
.Wz9W9ccCmgwHodFs .Xe8ysRwWTRwK_032 {
  flex-shrink: 0;
  font-size: 12px;
  line-height: 20px;
  padding: 0 8px;
  border-radius: 10px;
  background: #f5f5f5;
  color: #595959;
}
.Wz9W9ccCmgwHodFs .Fod4ps3Gmf0GAiGH {
  color: #d46b08;
  background: #fff7e6;
}
.Wz9W9ccCmgwHodFs .jnEuP53OsAsUgt2F {
  color: #1677ff;
  background: #e6f4ff;
}
.Wz9W9ccCmgwHodFs .lMR9GLSuizkxBZau {
  color: #389e0d;
  background: #f6ffed;
}
.Wz9W9ccCmgwHodFs .oVUJY0EkknEglZ0K {
  margin: 8px 0;
  font-size: 16px;
}
.Wz9W9ccCmgwHodFs .vOC5cuZ4gQk60u7i {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  line-height: 1.6;
  margin-top: 4px;
}
.Wz9W9ccCmgwHodFs .vOC5cuZ4gQk60u7i .EYCTQdeKgZk2Ct57 {
  flex-shrink: 0;
  color: #8c8c8c;
}
.Wz9W9ccCmgwHodFs .vOC5cuZ4gQk60u7i .Ef4XWwwjSF8SZqBU {
  text-align: right;
  word-break: break-all;
  color: #262626;
}
.Wz9W9ccCmgwHodFs .iKsKa2hfpTwJChFn {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.6;
  color: #262626;
  word-break: break-all;
  background: #fff;
  border-radius: 6px;
  padding: 8px;
}
.Wz9W9ccCmgwHodFs .K1v4mLp8J4Eu53rG {
  margin-top: 12px;
}
.Wz9W9ccCmgwHodFs .jXJxSutPt3It31rA {
  display: flex;
  justify-content: center;
  margin-top: 4px;
}
.Wz9W9ccCmgwHodFs .bz8igFQoUpQK0Ds7 .QxjjBhfpp30fhoQW,
.Wz9W9ccCmgwHodFs .bz8igFQoUpQK0Ds7 .fMsAwJ3NAPAeL9NH {
  word-break: break-all;
}
.Wz9W9ccCmgwHodFs .bz8igFQoUpQK0Ds7 .iI4KbSvrUjIWRhyq {
  padding: 8px 0;
}
.Wz9W9ccCmgwHodFs .bz8igFQoUpQK0Ds7 .YQb0pehE0ncGb6uq {
  position: static;
  width: 100%;
  max-height: none;
  box-shadow: none;
}
.Wz9W9ccCmgwHodFs .ant-card-body {
  padding: 12px;
}
.Wz9W9ccCmgwHodFs .ant-form-item {
  margin-bottom: 12px;
}
.Wz9W9ccCmgwHodFs .ant-input,
.Wz9W9ccCmgwHodFs .ant-select-selector,
.Wz9W9ccCmgwHodFs .ant-picker-input > input {
  font-size: 16px;
}
.Wz9W9ccCmgwHodFs .ant-picker-range {
  min-width: 0;
}
.Wz9W9ccCmgwHodFs .ant-picker-input {
  min-width: 0;
}
@media (max-width: 768px) {
  .complaint-range-popup {
    max-width: calc(100vw - 16px);
  }
  .complaint-range-popup .ant-picker-panel-container {
    max-width: calc(100vw - 16px);
    max-height: 70vh;
    overflow: auto;
  }
  .complaint-range-popup .ant-picker-panels {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/newComplaint/index.modules.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,yBAAA;AACF;AAHA;EAKI,aAAA;EACA,yBAAA;EACA,mBAAA;AACJ;AARA;EAUM,iBAAA;AACN;AAXA;EAeI,gBAAA;AADJ;AAdA;EAkBM,WAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AADN;AArBA;EAyBQ,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AADR;AA5BA;EAgCU,gBAAA;AADV;AA/BA;EAwCM,uBAAA;AANN;AAlCA;EA6CI,kBAAA;EACA,cAAA;AARJ;AAtCA;EAiDM,gBAAA;AARN;AAzCA;EAqDM,eAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AATN;AAhDA;EA6DM,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAVN;AAaM;EACE,cAAA;AAXR;AAnEA;EAkFQ,cAAA;EACA,gCAAA;EACA,gBAAA;AAZR;AAcQ;EACE,mBAAA;AAZV;AA3EA;EA8FI,aAAA;EACA,2BAAA;EACA,mBAAA;AAhBJ;AAhFA;EAmGM,WAAA;EACA,YAAA;EACA,mBAAA;EAEA,kBAAA;EACA,iBAAA;AAjBN;AAvFA;EA+GI,cAAA;EACA,iBAAA;AArBJ;AA3FA;EAoHI,WAAA;AAtBJ;AA0BA;EACE,WAAA;EACA,SAAA;EACA,uBAAA;EACA,sBAAA;AAxBF;AAoBA;EAOI,wBAAA;EACA,SAAA;AAxBJ;AAgBA;EAWM,cAAA;AAxBN;AAaA;EAeM,OAAA;AAzBN;AAUA;EAqBM,gBAAA;EACA,mBAAA;EACA,mBAAA;AA5BN;AAKA;EA0BQ,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AA5BR;AA8BQ;EACE,cAAA;EACA,gBAAA;EACA,kCAAA;AA5BV;AAPA;EA0CI,aAAA;EACA,sBAAA;EACA,SAAA;AAhCJ;AAZA;EAgDI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAjCJ;AAlBA;EAuDI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,QAAA;AAlCJ;AAxBA;EA8DI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAnCJ;AA9BA;EAqEI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AApCJ;AAvCA;EA+EI,cAAA;EACA,mBAAA;AArCJ;AA3CA;EAoFI,cAAA;EACA,mBAAA;AAtCJ;AA/CA;EAyFI,cAAA;EACA,mBAAA;AAvCJ;AAnDA;EA8FI,aAAA;EACA,eAAA;AAxCJ;AAvDA;EAmGI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAzCJ;AA/DA;EA2GM,cAAA;EACA,cAAA;AAzCN;AAnEA;EAgHM,iBAAA;EACA,qBAAA;EACA,cAAA;AA1CN;AAxEA;EAuHI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AA5CJ;AAlFA;EAkII,gBAAA;AA7CJ;AArFA;EAsII,aAAA;EACA,uBAAA;EACA,eAAA;AA9CJ;AA1FA;;EA8IM,qBAAA;AAhDN;AA9FA;EAkJM,cAAA;AAjDN;AAjGA;EAsJM,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAlDN;AAvGA;EA+JM,aAAA;AArDN;AA1GA;EAmKM,mBAAA;AAtDN;AA7GA;;;EAyKM,eAAA;AAvDN;AAlHA;EA6KM,YAAA;AAxDN;AArHA;EAiLM,YAAA;AAzDN;AAgEI;EAAA;IACE,6BAAA;EA7DJ;EA4DE;IAII,6BAAA;IACA,gBAAA;IACA,cAAA;EA7DN;EAuDE;IAUI,sBAAA;EA9DN;AACF","sourcesContent":[".complaintWrapper {\n  margin: 20px auto;\n  width: calc(100vw - 60px);\n\n  .btnGroup {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    .btnSearchStyle {\n      margin-left: 12px;\n    }\n  }\n\n  .complaintMain {\n    margin-top: 10px;\n\n    .complaintMainTabs {\n      width: 100%;\n      margin-bottom: 20px;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n\n      .complaintMainTabsItem {\n        margin-right: 30px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n\n        .redTooltip {\n          margin-left: 5px;\n\n        }\n      }\n    }    \n\n    //  表格行高，避免子菜单遮挡\n    .tableRow {\n      height: auto !important;\n    }\n  }\n\n  .orderIdList {\n    position: relative;\n    padding: 4px 0;\n\n    .firstOrder {\n      line-height: 1.6;\n    }\n\n    .showMore {\n      font-size: 12px;\n      color: #999; // 改为主题色，提示可点击\n      font-weight: bold;\n      cursor: pointer;\n      margin-top: 2px;\n    }\n\n    .subMenu {\n      display: none; // 默认隐藏\n      position: absolute;\n      width: 300px;\n      max-height: 200px;\n      overflow-y: auto;\n      top: 100%; // 改为top，避免遮挡上方内容\n      left: 0;\n      z-index: 999; // 提高层级，确保不被遮挡\n      background: #fff;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); // 增加阴影，提升视觉层次\n      border: 1px solid #f0f0f0;\n      border-radius: 4px;\n      margin-top: 4px; // 与上方内容留间距\n      padding: 4px 8px;\n\n      // 展开时显示\n      &.show {\n        display: block;\n      }\n\n      .orderItem {\n        padding: 6px 0;\n        border-bottom: 1px solid #f0f0f0;\n        line-height: 1.6;\n\n        &:last-child {\n          border-bottom: none;\n        }\n      }\n    }\n  }\n\n  .tags {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n\n    .tagIcon {\n      width: 10px;\n      height: 10px;\n      background: #52c41a;\n      // background: #1677ff;\n      border-radius: 50%;\n      margin-right: 5px;\n\n    }\n\n  }\n\n  .active {\n    color: #1677ff;\n    font-weight: bold;\n  }\n\n  .rangePicker {\n    width: 100%;\n  }\n}\n\n.isMobile {\n  width: 100%;\n  margin: 0;\n  padding: 12px 12px 24px;\n  box-sizing: border-box;\n\n  .btnGroup {\n    justify-content: stretch;\n    gap: 12px;\n\n    .btnSearchStyle {\n      margin-left: 0;\n    }\n\n    button {\n      flex: 1;\n    }\n  }\n\n  .complaintMain {\n    .complaintMainTabs {\n      overflow-x: auto;\n      margin-bottom: 12px;\n      padding-bottom: 4px;\n\n      .complaintMainTabsItem {\n        margin-right: 16px;\n        flex-shrink: 0;\n        white-space: nowrap;\n        min-height: 36px;\n        padding: 6px 2px;\n\n        &.active {\n          color: #1677ff;\n          font-weight: 600;\n          box-shadow: inset 0 -2px 0 #1677ff;\n        }\n      }\n    }\n  }\n\n  .mobileList {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .mobileCard {\n    border: 1px solid #f0f0f0;\n    border-radius: 8px;\n    padding: 12px;\n    background: #fafafa;\n  }\n\n  .mobileCardHead {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .mobileProduct {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1f2937;\n    word-break: break-all;\n  }\n\n  .mobileStatus {\n    flex-shrink: 0;\n    font-size: 12px;\n    line-height: 20px;\n    padding: 0 8px;\n    border-radius: 10px;\n    background: #f5f5f5;\n    color: #595959;\n  }\n\n  .statusPending {\n    color: #d46b08;\n    background: #fff7e6;\n  }\n\n  .statusProcessing {\n    color: #1677ff;\n    background: #e6f4ff;\n  }\n\n  .statusDone {\n    color: #389e0d;\n    background: #f6ffed;\n  }\n\n  .mobileAmount {\n    margin: 8px 0;\n    font-size: 16px;\n  }\n\n  .mobileRow {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 13px;\n    line-height: 1.6;\n    margin-top: 4px;\n\n    .label {\n      flex-shrink: 0;\n      color: #8c8c8c;\n    }\n\n    .value {\n      text-align: right;\n      word-break: break-all;\n      color: #262626;\n    }\n  }\n\n  .mobileContent {\n    margin-top: 8px;\n    font-size: 13px;\n    line-height: 1.6;\n    color: #262626;\n    word-break: break-all;\n    background: #fff;\n    border-radius: 6px;\n    padding: 8px;\n  }\n\n  .mobileAction {\n    margin-top: 12px;\n  }\n\n  .mobilePagination {\n    display: flex;\n    justify-content: center;\n    margin-top: 4px;\n  }\n\n  .orderIdList {\n    .firstOrder,\n    .orderItem {\n      word-break: break-all;\n    }\n\n    .showMore {\n      padding: 8px 0;\n    }\n\n    .subMenu {\n      position: static;\n      width: 100%;\n      max-height: none;\n      box-shadow: none;\n    }\n  }\n\n  :global {\n    .ant-card-body {\n      padding: 12px;\n    }\n\n    .ant-form-item {\n      margin-bottom: 12px;\n    }\n\n    .ant-input,\n    .ant-select-selector,\n    .ant-picker-input > input {\n      font-size: 16px;\n    }\n\n    .ant-picker-range {\n      min-width: 0;\n    }\n\n    .ant-picker-input {\n      min-width: 0;\n    }\n  }\n}\n\n:global {\n  .complaint-range-popup {\n    @media (max-width: 768px) {\n      max-width: calc(100vw - 16px);\n\n      .ant-picker-panel-container {\n        max-width: calc(100vw - 16px);\n        max-height: 70vh;\n        overflow: auto;\n      }\n\n      .ant-picker-panels {\n        flex-direction: column;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"complaintWrapper": `C7thQ1oicKAkghpP`,
	"btnGroup": `j1Tf1F92k7EbozCH`,
	"btnSearchStyle": `MZYeXebNzuQpvDnz`,
	"complaintMain": `YcUdBTFv30g6_qZn`,
	"complaintMainTabs": `mBDRmp6eeBsni0qu`,
	"complaintMainTabsItem": `E_XsfxqWxoZaBg26`,
	"redTooltip": `eKt3nK0FWa87qO_G`,
	"tableRow": `jmqKFPShXYIWyE1Y`,
	"orderIdList": `bz8igFQoUpQK0Ds7`,
	"firstOrder": `QxjjBhfpp30fhoQW`,
	"showMore": `iI4KbSvrUjIWRhyq`,
	"subMenu": `YQb0pehE0ncGb6uq`,
	"show": `VSIGrhmL_QUjBJni`,
	"orderItem": `fMsAwJ3NAPAeL9NH`,
	"tags": `iDzBdqmcto8q4ycM`,
	"tagIcon": `_cTGRYKTUKgk5Uo4`,
	"active": `GlhocLTKrUsteDyc`,
	"rangePicker": `uzCcsw4oSskOfvMF`,
	"isMobile": `Wz9W9ccCmgwHodFs`,
	"mobileList": `CHTpelOoXRQMA7XS`,
	"mobileCard": `Xm0RXffSZCoKJBR7`,
	"mobileCardHead": `K6X9o26VYI0DYefH`,
	"mobileProduct": `VM9cXdGUGo1mf9Hc`,
	"mobileStatus": `Xe8ysRwWTRwK_032`,
	"statusPending": `Fod4ps3Gmf0GAiGH`,
	"statusProcessing": `jnEuP53OsAsUgt2F`,
	"statusDone": `lMR9GLSuizkxBZau`,
	"mobileAmount": `oVUJY0EkknEglZ0K`,
	"mobileRow": `vOC5cuZ4gQk60u7i`,
	"label": `EYCTQdeKgZk2Ct57`,
	"value": `Ef4XWwwjSF8SZqBU`,
	"mobileContent": `iKsKa2hfpTwJChFn`,
	"mobileAction": `K1v4mLp8J4Eu53rG`,
	"mobilePagination": `jXJxSutPt3It31rA`
};
export default ___CSS_LOADER_EXPORT___;
